import { Component, Input, inject } from "@angular/core";
import { ThirdPartyModel } from "@models/thirdparty/ThirdpartyModel";
import { IncidentLinkModel } from "@app/incident/models/incident-link.model";
import { IncidentThirdPartyService } from "@app/incident/services/incident-thirdparty.service";
import moment from "moment";

@Component({
    selector: "thirdparty-incidents",
    templateUrl: "./thirdparty-incidents.component.html",
    styleUrls: ["./thirdparty-incidents.component.scss"],
    standalone: false
})
export class ThirdPartyIncidentsComponent {
    private incidentThirdPartyDS = inject(IncidentThirdPartyService);

    @Input() model: ThirdPartyModel;
    @Input() disabled;

    linked: IncidentLinkModel[];
    isLoading = true;

    load() {
        if (!this.model) {
            return;
        }

        this.isLoading = true;

        this.incidentThirdPartyDS.getLinkedIncidentsAsync(this.model.Guid).subscribe((data) => {
            const mappedIncidents: IncidentLinkModel[] = [];
            if (data) {
                data.forEach((item) => {
                    item.displayItems = [];

                    item.displayItems.push({
                        Header: "Is affected by",
                        Value: item.isAffectedBy ? "Yes" : "No",
                    });
                    item.displayItems.push({
                        Header: "Is caused by",
                        Value: item.isCausedBy ? "Yes" : "No",
                    });
                    item.displayItems.push({
                        Header: "Description",
                        Value: item.description,
                    });

                    item.displayItems.push({
                        Header: "Status",
                        Value: item.status,
                    });

                    if (item.due_Date !== null && item.due_Date !== undefined) {
                        const due_Date = moment(item.due_Date).format("DD-MM-YYYY");

                        item.displayItems.push({
                            Header: "Due date",
                            Value: due_Date,
                        });
                    } else {
                        item.displayItems.push({
                            Header: "Due date",
                            Value: null,
                        });
                    }

                    if (item.date_Occurred !== null && item.date_Occurred !== undefined) {
                        const date_Occurred = moment(item.date_Occurred).format("DD-MM-YYYY");

                        item.displayItems.push({
                            Header: "Date occurred",
                            Value: date_Occurred,
                        });
                    } else {
                        item.displayItems.push({
                            Header: "Date occurred",
                            Value: null,
                        });
                    }
                    mappedIncidents.push(item);
                });
            }
            this.linked = mappedIncidents;
            this.isLoading = false;
        });
    }
}
